import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import AsyncSelect from "react-select/async";
import MaterialTable from "material-table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CurrencyInput from "react-currency-input-field";
import { useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import ContentLoader from "react-content-loader";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert"; // Import

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import EditReceiptService from "../../../services/receipts/editReceiptService";
import Helper from "../../../Helper";
import ApplyReceiptService from "../../../services/receipts/applyGlobalReceipt";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import DocumentUpload from "../../../services/document/documentupload";

function EditRecipts({ setCustomData }) {
	const [successful, setSuccessful] = useState(false);
	const [loading, setLoading] = useState(false);
	const [disable, setDisable] = useState(false);
	const [canceldisable, setCancelDisable] = useState(false);
	const [applyloading, setApplyLoading] = useState(false);
	const [cancelbtnloading, setCancelBtnLoading] = useState(false);

	const [receipt_number, setReceipt_number] = useState("");
	const [receipt_date, setReceipt_date] = useState("");
	const [receipt_amount, setReceipt_amount] = useState("");
	const [applied_amount, setApplied_amount] = useState("");
	const [remittance_bank, setRemittance_bank] = useState("");
	const [originalremittance, setOriginalremittance] = useState('')
	const [receipt_method, setReceipt_method] = useState("");
	const [originalMethod, setOriginalMethod] = useState('')
	const [receipt_reference, setReceipt_reference] = useState("");
	const [originalReference, setOriginalRefernce] = useState("");
	const [status, setStatus] = useState("");
	const [comments, setComments] = useState("");
	const [overide_application, setOveride_application] = useState("");
	const [selectedValue2, setSelectedValue2] = useState(null);
	const [inputvalue2, setValue2] = useState("");
	const [selectedValue, setSelectedValue] = useState(null);
	const [inputvalue, setValue] = useState("");
	const [items, setItems] = useState([]);
	const [invoicepaid, setInvoicePaid] = useState([]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [isEditing, setIsEditing] = useState(false);
	const [originalSelectedValue2, setOriginalSelectedValue2] = useState(null);
	const [originalAttributes, setOriginalAttributes] = useState([
		{ attribute0: "" },
		{ attribute1: "" },
		{ attribute2: "" },
		{ attribute3: "" },
		{ attribute4: "" },
		{ attribute5: "" },
		{ attribute6: "" },
		{ attribute7: "" },
		{ attribute8: "" },
		{ attribute9: "" },
		{ attribute10: "" },
		{ attribute11: "" },
		{ attribute12: "" },
		{ attribute13: "" },
		{ attribute14: "" },
	])
	const [originalAmount, setOriginalAmount] = useState(null)
	const [receiptapplicationbutton, setReceiptApplicationButton] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [cashLoading, setCashLoading] = useState(false)
	const [attribute, setAttribute] = useState([
		{ attribute0: "" },
		{ attribute1: "" },
		{ attribute2: "" },
		{ attribute3: "" },
		{ attribute4: "" },
		{ attribute5: "" },
		{ attribute6: "" },
		{ attribute7: "" },
		{ attribute8: "" },
		{ attribute9: "" },
		{ attribute10: "" },
		{ attribute11: "" },
		{ attribute12: "" },
		{ attribute13: "" },
		{ attribute14: "" },
	]);
	const [extrafiledreceipt, setExtraFiled] = useState([]);
	const checkBtn = useRef();
	const [object_name, setObject_name] = useState('Receipts')
	const [originalComment, setOriginalComment] = useState('')
	const [options, setOptions] = useState([]);
	const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm();
	const form = useRef();
	const { state } = useLocation();
	const invoicePaidRef = useRef(null);

	const getExtrafiled = () => {
		setIsLoading(true)
		GetCompanyInfoService.getExtraFiled().then((response) => {
			setExtraFiled(response.data.existrecipt);
			setTimeout(() => {
				setIsLoading(false)
			}, 1000);
		})
	};

	useEffect(() => {
		getExtrafiled();
		setIsLoading(true)
		EditReceiptService.getReceiptInvoice(state).then((response) => {
			setItems(response.data);
		})
		EditReceiptService.getReceiptInvoicepaid(state).then((response) => {
			setInvoicePaid(response.data);
		})

		// setTimeout(() => {
		setIsLoading(false)
		// }, 1000);
	}, [successful, state]);
	const locale = localStorage.getItem('locale')

	const getreceipts = (id) => {
		// if (state !== null) {
		setIsLoading(true)
		EditReceiptService.getReceiptDetail(state).then((response) => {
			setReceipt_number(response.data.receipt_number);
			setReceipt_date(response.data.receipt_date);
			setReceipt_amount(response.data.receipt_amount);
			setApplied_amount(response.data.applied_amount);
			setSelectedValue(response.data.customer_id);
			setSelectedValue2(response.data.contract_id);
			setStatus(response.data.status);
			setComments(response.data.comments);
			setOriginalComment(response.data.comment)
			setRemittance_bank(response.data.remittance_bank);
			setReceipt_method(response.data.receipt_method);
			setReceipt_reference(response.data.receipt_reference);
			setOveride_application(response.data.overide_application);
			setAttribute([
				{ attribute0: response.data.receiptattribute1 },
				{ attribute1: response.data.receiptattribute2 },
				{ attribute2: response.data.receiptattribute3 },
				{ attribute3: response.data.receiptattribute4 },
				{ attribute4: response.data.receiptattribute5 },
				{ attribute5: response.data.receiptattribute6 },
				{ attribute6: response.data.receiptattribute7 },
				{ attribute7: response.data.receiptattribute8 },
				{ attribute8: response.data.receiptattribute9 },
				{ attribute9: response.data.receiptattribute10 },
				{ attribute10: response.data.receiptattribute11 },
				{ attribute11: response.data.receiptattribute12 },
				{ attribute12: response.data.receiptattribute13 },
				{ attribute13: response.data.receiptattribute14 },
				{ attribute14: response.data.receiptattribute15 },
			]);
			// setTimeout(() => {
			setIsLoading(false)
			// }, 1000);
			reset({
				receiptmethod: response.data.receipt_method,
				selectedValue: response.data.customer_id,
				selectedValue2: response.data.contract_id,
				receiptamount: response.data.receipt_amount,
				receipt_number: response.data.receipt_number,
				receiptdate: response.data.receipt_date,
			});
		})

	}

	useEffect(() => {
		setIsLoading(true)
		EditReceiptService.getReceiptDetail(state).then((response) => {
			setReceipt_number(response.data.receipt_number);
			setReceipt_date(response.data.receipt_date);
			setReceipt_amount(response.data.receipt_amount);
			setApplied_amount(response.data.applied_amount);
			setSelectedValue(response.data.customer_id);
			setSelectedValue2(response.data.contract_id);
			setStatus(response.data.status);
			setComments(response.data.comments);
			setOriginalComment(response.data.comments)
			setRemittance_bank(response.data.remittance_bank);
			setOriginalremittance(response.data.remittance_bank)
			setReceipt_method(response.data.receipt_method);
			setOriginalMethod(response.data.receipt_method)
			setReceipt_reference(response.data.receipt_reference);
			setOriginalRefernce(response.data.receipt_reference)
			setOveride_application(response.data.overide_application);
			setAttribute([
				{ attribute0: response.data.receiptattribute1 },
				{ attribute1: response.data.receiptattribute2 },
				{ attribute2: response.data.receiptattribute3 },
				{ attribute3: response.data.receiptattribute4 },
				{ attribute4: response.data.receiptattribute5 },
				{ attribute5: response.data.receiptattribute6 },
				{ attribute6: response.data.receiptattribute7 },
				{ attribute7: response.data.receiptattribute8 },
				{ attribute8: response.data.receiptattribute9 },
				{ attribute9: response.data.receiptattribute10 },
				{ attribute10: response.data.receiptattribute11 },
				{ attribute11: response.data.receiptattribute12 },
				{ attribute12: response.data.receiptattribute13 },
				{ attribute13: response.data.receiptattribute14 },
				{ attribute14: response.data.receiptattribute15 },
			]);

			reset({
				receiptmethod: response.data.receipt_method,
				selectedValue: response.data.customer_id,
				selectedValue2: response.data.contract_id,
				receiptamount: response.data.receipt_amount,
				receipt_number: response.data.receipt_number,
				receiptdate: response.data.receipt_date,
			});
			setIsLoading(false)

		})
	}, [successful]);

	const receiptvalue = () => {
		setIsLoading(true)
		EditReceiptService.getReceiptDetail(state).then((response) => {
			setReceipt_number(response.data.receipt_number);
			setReceipt_date(response.data.receipt_date);
			setReceipt_amount(response.data.receipt_amount);
			setApplied_amount(response.data.applied_amount);
			setSelectedValue(response.data.customer_id);
			setSelectedValue2(response.data.contract_id);
			setStatus(response.data.status);
			setComments(response.data.comments);
			setOriginalComment(response.data.comments)
			setRemittance_bank(response.data.remittance_bank);
			setReceipt_method(response.data.receipt_method);
			setReceipt_reference(response.data.receipt_reference);
			setOveride_application(response.data.overide_application);
			setAttribute([
				{ attribute0: response.data.receiptattribute1 },
				{ attribute1: response.data.receiptattribute2 },
				{ attribute2: response.data.receiptattribute3 },
				{ attribute3: response.data.receiptattribute4 },
				{ attribute4: response.data.receiptattribute5 },
				{ attribute5: response.data.receiptattribute6 },
				{ attribute6: response.data.receiptattribute7 },
				{ attribute7: response.data.receiptattribute8 },
				{ attribute8: response.data.receiptattribute9 },
				{ attribute9: response.data.receiptattribute10 },
				{ attribute10: response.data.receiptattribute11 },
				{ attribute11: response.data.receiptattribute12 },
				{ attribute12: response.data.receiptattribute13 },
				{ attribute13: response.data.receiptattribute14 },
				{ attribute14: response.data.receiptattribute15 },
			]);
			setOriginalAttributes([
				{ attribute0: response.data.receiptattribute1 },
				{ attribute1: response.data.receiptattribute2 },
				{ attribute2: response.data.receiptattribute3 },
				{ attribute3: response.data.receiptattribute4 },
				{ attribute4: response.data.receiptattribute5 },
				{ attribute5: response.data.receiptattribute6 },
				{ attribute6: response.data.receiptattribute7 },
				{ attribute7: response.data.receiptattribute8 },
				{ attribute8: response.data.receiptattribute9 },
				{ attribute9: response.data.receiptattribute10 },
				{ attribute10: response.data.receiptattribute11 },
				{ attribute11: response.data.receiptattribute12 },
				{ attribute12: response.data.receiptattribute13 },
				{ attribute13: response.data.receiptattribute14 },
				{ attribute14: response.data.receiptattribute15 },
			])

			reset({
				receiptmethod: response.data.receipt_method,
				selectedValue: response.data.customer_id,
				selectedValue2: response.data.contract_id,
				receiptamount: response.data.receipt_amount,
				receipt_number: response.data.receipt_number,
				receiptdate: response.data.receipt_date,
			});
			EditReceiptService.getReceiptInvoice(state).then((response) => {
				setItems(response.data);
			})

			EditReceiptService.getReceiptInvoicepaid(state).then((response) => {
				setInvoicePaid(response.data);
			})
			setIsLoading(false)

		})
	}

	const handelInputChange2 = (value1) => {
		setValue2(value1);
	};

	const handelChange2 = (value1) => {
		setSelectedValue2(value1);
		reset({
			selectedValue2: value1,
		});
		loadInitialOptions(value1.customer_name)
		reset({
			selectedValue2: value1,
			selectedValue: value1.id
		})
	};

	const loadOptions2 = async (inputValue2) => {
		if (inputValue2 !== "") {
			const response = await axios.get(
				API +
				`contracts/contractsactive/filter/?id=${inputValue2}&&customer_id=${selectedValue ? selectedValue.id : ""
				}`,
				{ headers: authHeader() }
			);
			return response.data.data;
		}
	};

	const handelInputChange = (value) => {
		setValue(value);
	};

	const handelChange = (value) => {
		setSelectedValue(value);
		loadInitialOptions(value.customer_name)
		reset({
			selectedValue: value,
		});
	};

	const handelReceipt_Date = (value) => {
		setReceipt_date(value);
		reset({
			receiptdate: value,
		});
	};

	const loadOptions = async (inputValue) => {
		const responseJSON = await axios.get(
			API + `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
			{ headers: authHeader() }
		);
		return responseJSON.data.data;
	};

	const loadInitialOptions = async (customer) => {
		if (customer !== undefined) {
			const responseJSON = await axios.get(
				API + `parties/vendor/?party_type=Customer&&customer_name=${customer}`,
				{ headers: authHeader() }
			);
			setOptions(responseJSON.data.data);
			setSelectedValue(responseJSON.data.data[0])
		} else {
			const responseJSON = await axios.get(
				API +
				`parties/vendor/?party_type=Customer&&customer_name=${selectedValue.customer_name}`,
				{ headers: authHeader() }
			);
			setOptions(responseJSON.data.data);
		}

	};

	useEffect(() => {
		loadInitialOptions()
	}, [selectedValue])

	const handleView = (id, status) => {
		if (status === "Saved" || status === "Completed") {
			navigate("/billing/viewinvoices", { state: id });
		} else {
			navigate("/billing/editinvoices", { state: id });
		}
	};

	const handleApplyManually = (invoiceId) => {
		let contract_id = null;
		let recieptamt = 0;
		if (selectedValue2 === null) {
			contract_id = selectedValue2;
		} else {
			contract_id = selectedValue2.id;
		}
		recieptamt = receipt_amount - applied_amount;
		ApplyReceiptService.applyReceipt(
			state,
			recieptamt,
			applied_amount,
			contract_id,
			invoiceId
		).then((response) => {
			if (response.data.success) {
				setSuccessful(true);
				setApplied_amount(response.data.applied_amount);
				toast.success(`${response.data.response}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
				receiptvalue()
			} else {
				receiptvalue()
				toast.error(`${response.data.error}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
				setSuccessful(false);
			}
		})

	};

	const handleApplyGlobally = () => {
		setApplyLoading(true);
		let contract_id = null;
		let recieptamt = 0;
		if (selectedValue2 === null) {
			contract_id = selectedValue2;
		} else {
			contract_id = selectedValue2.id;
		}
		recieptamt = receipt_amount - applied_amount;
		ApplyReceiptService.applyReceipt(
			state,
			recieptamt,
			applied_amount,
			contract_id
		).then((response) => {
			if (response.data.success) {
				setSuccessful(true);
				setApplyLoading(false);
				setApplied_amount(response.data.applied_amount);
				setTimeout(() => {
					navigate("/receipts");
				}, 1000);
				toast.success(`${response.data.response}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
			} else {
				toast.error(`${response.data.error}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
				setSuccessful(false);
				setApplyLoading(false);
			}
		})

	};

	const navigate = useNavigate();

	const handleRegister = (value) => {
		setSuccessful(false);
		setLoading(true);
		setDisable(true)
		form.current.validateAll();
		let customer_id = null;
		let contract_id = null;
		if (checkBtn.current.context._errors.length === 0) {
			if (selectedValue === null) {
				customer_id = selectedValue;
			} else {
				customer_id = selectedValue.id;
			}
			if (selectedValue2 === null) {
				contract_id = selectedValue2;
			} else {
				contract_id = selectedValue2.id;
			}
			EditReceiptService.updateReceipt(
				receipt_number,
				Helper.DatePicker(receipt_date),
				receipt_amount,
				customer_id,
				contract_id,
				remittance_bank,
				receipt_method,
				receipt_reference,
				status,
				comments,
				overide_application,
				attribute
			).then((response) => {
				if (response.data.success) {
					setLoading(false);
					setDisable(false)
					toast.success(`${response.data.response}`, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					});
				} else {
					toast.error(`${response.data.error}`, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					});
					setSuccessful(false);
					setDisable(false)
					setLoading(false)
				}
			})

		}
	};

	const updatereceipt = () => {
		setCancelDisable(true)
		setCancelBtnLoading(true)

		let customer_id = null;
		let contract_id = null;
		if (selectedValue === null) {
			customer_id = selectedValue;
		} else {
			customer_id = selectedValue.id;
		}
		if (selectedValue2 === null) {
			contract_id = selectedValue2;
		} else {
			contract_id = selectedValue2.id;
		}
		EditReceiptService.updateReceiptstatus(
			state,
			receipt_number,
			Helper.DatePicker(receipt_date),
			receipt_amount,
			customer_id,
			contract_id,
			remittance_bank,
			receipt_method,
			receipt_reference,
			status,
			overide_application,
			attribute
		).then((response) => {
			if (response.data.success) {
				setCancelBtnLoading(false)
				setCancelDisable(false)
				getreceipts()
				setTimeout(() => {
					navigate("/receipts")
				}, 2000)
				toast.success(`${response.data.response}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
			} else {
				toast.error(`${response.data.error}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
				setCancelDisable(false)
				setCancelBtnLoading(false)

			}
		})

	}


	const onChangeextrafileds = (e, index) => {
		const { name, value } = e.target;
		const rowsInput = [...attribute];
		rowsInput[index][name] = value;
		setAttribute(rowsInput);
	};

	useEffect(() => {
		setCustomData({
			object_id: state,
			object_name: object_name
		})
	}, [object_name, setCustomData, state])

	const handleRowSelectionChange = (rows) => {
		setSelectedRows(rows.map(row => row.invoice_id.id));
	};

	const handleReceiptReverse = (event) => {
		event.preventDefault();
		// setSuccessful(false)
		setReceiptApplicationButton(true)
		axios.post(API + `receipts/reverse_receipt_applications/${state}/`, { invoice_ids: selectedRows }, { headers: authHeader() })
			.then(response => {
				if (response.data.success === 1) {
					toast.success(response.data.response, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					})
					setTimeout(() => {
						// setSuccessful(false);
						setReceiptApplicationButton(false)

						receiptvalue()
						setSelectedRows([])
					}, 2000)

				}
				else {
					setReceiptApplicationButton(false)
					toast.error(response.data.error, {
						position: "top-right",
						autoClose: 3000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					})
				}
			})
			.catch((error) => {
				setReceiptApplicationButton(false)
				toast.error('Something went wrong,', {
					position: "top-right",
					autoClose: 4000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				})

			});
	};

	const handleCashReceiptReversal = (reverse_comment) => {
		// event.preventDefault();
		// setSuccessful(false)
		setCashLoading(true)
		axios.post(API + `receipts/reverse_cash_receipt/`, { receipt_id: state, reverse_comment: reverse_comment, }, { headers: authHeader() })
			.then(response => {
				if (response.data.success === 1) {
					toast.success(response.data.response, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					})
					setTimeout(() => {
						setCashLoading(false);
						setSuccessful(false)
						receiptvalue()
						navigate("/receipts")
						// navigate("/receipts/viewreceipts", { state: state })
						// setSelectedRows([])
					}, 2000)

				}
				else {
					setCashLoading(false)
					toast.error(response.data.error, {
						position: "top-right",
						autoClose: 3000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					})
				}
			})
			.catch((error) => {
				setCashLoading(false)
				toast.error('Something went wrong,', {
					position: "top-right",
					autoClose: 4000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				})

			});
	};

	const handleCashReceiptReversalconfirmAlert = () => {
		let reverseComment = "";

		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className="react-confirm-alert-body">
						<h6>
							Confirm reversal and provide reason. 
						</h6>

						{/* ✅ TEXTAREA ADDED */}
						<textarea
							className="form-control mt-3"
							placeholder="Enter reverse reason..."
							onChange={(e) => (reverseComment = e.target.value)}
						/>

						<div className="react-confirm-alert-button-group mt-3">
							<button onClick={onClose}>Cancel</button>
							<button
								onClick={() => {
									handleCashReceiptReversal(reverseComment);
									onClose();
								}}
							>
								Save
							</button>
						</div>
					</div>
				);
			},
		});
	};

	const handleEdit = () => {
		setIsEditing(true);
		// setOriginalSelectedValue2(selectedValue2);
		// setOriginalAmount(receipt_amount)
		// setOriginalComment(comments)
		// setOriginalAttributes(attribute)
	};

	const handleSave = () => {
		setIsEditing(false);

		let customer_id = null;
		let contract_id = null;
		if (selectedValue === null) {
			customer_id = selectedValue;
		} else {
			customer_id = selectedValue.id;
		}
		if (selectedValue2 === null) {
			contract_id = selectedValue2;
		} else {
			contract_id = selectedValue2.id;
		}
		EditReceiptService.updateReceipt(
			// state,
			receipt_number,
			Helper.DatePicker(receipt_date),
			receipt_amount,
			customer_id,
			contract_id,
			remittance_bank,
			receipt_method,
			receipt_reference,
			status,
			comments,
			overide_application,
			attribute
		).then((response) => {
			if (response.data.success) {
				// setCancelBtnLoading(false)
				// setCancelDisable(false)

				// getreceipts(response.data.receipt_id)
				getreceipts()
				setIsEditing(false)
				// setTimeout(() => {
				// 	navigate("/receipts/editreceipts")
				// }, 2000)
				toast.success(`${response.data.response}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
			} else {
				toast.error(`${response.data.error}`, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
				});
				// setCancelDisable(false)
				// setCancelBtnLoading(false)

			}
		})
	};

	const handleCancelEdit = () => {
		// setSelectedValue2(originalSelectedValue2);
		// setReceipt_amount(originalAmount)
		setComments(originalComment)
		setAttribute(originalAttributes)
		setRemittance_bank(originalremittance)
		setReceipt_method(originalMethod)
		setReceipt_reference(originalReference)
		setIsEditing(false);
	};

	const handlesmoothInvoice = () => {
		invoicePaidRef.current.scrollIntoView({ behavior: 'smooth' });
	}

	const [currentPage, setCurrentPage] = useState(1);
	const [documents, setDocuments] = useState([]);

	const recordsPerPage = 1;

	const indexOfLastRecord = currentPage * recordsPerPage;
	const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
	const currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);

	const totalPages = Math.ceil(documents.length / recordsPerPage);

	const handleNext = () => {
		if (currentPage < totalPages) {
			setCurrentPage(prev => prev + 1);
		}
	};

	const handlePrevious = () => {
		if (currentPage > 1) {
			setCurrentPage(prev => prev - 1);
		}
	};

	useEffect(() => {
		DocumentUpload.viewListupload().then((res) => {
			console.log("res", res)
			setDocuments(res.data.data)
		}).catch((e) => {
			console.log('e', e)
		})
	}, []);

	const handleTages = () => {
		navigate('/doc')
	}

	const handleDownload = (fileUrl) => {
		const link = document.createElement('a');
		link.href = fileUrl;
		link.target = '_blank';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};
	return (
		<>
			<div className="page-wrapper">
				<ToastContainer />
				<div className="content container-fluid">
					<div className="header pb-0 pt-3">
						<div className="d-lg-flex">
							<div>
								<h5 className="mb-3">{t("Edit Receipt")}</h5>
								<h6><Link to="/receipts" className="tc">{t("Receipts")}</Link> / <span>{t("Edit Receipt")}</span></h6>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<div className="">
								<div className="row">
									<div className="col-md-8">
										<div className="card">
											<div className="card-body">
												{isLoading !== true ?
													<Form
														role="form text-left"
														onSubmit={handleSubmit(handleRegister)}
														ref={form}
														action="."
														method="POST"
														id="addReceiptForm"
													>
														{
															<>
																<div className="row">
																	<div className="col-xl-12">
																		<div className="form-group row">
																			<label className="col-lg-12 col-form-label required">
																				{t("Receipt Method")}{" "}
																				<Tooltip
																					content={t("ReceiptMethod_Tooltip")}
																				>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<select
																					value={receipt_method}
																					id="receiptmethod"
																					className="form-control input-lg"
																					data-live-search="true"
																					name="receiptmethod"
																					disabled={!isEditing}
																					{...register("receiptmethod", {
																						onChange: (e) => {
																							setReceipt_method(e.target.value);
																						},
																						required: true,
																					})}
																				>
																					<option value="">Select Method</option>
																					{locale === "en_US" ? (
																						<>
																							<option value="Check">
																								Check
																							</option>
																							<option value="Cash">Cash</option>
																							<option value="Card">Card</option>
																							<option value="ACH">ACH</option>
																						</>
																					) : (
																						<>
																							<option value="Cheque">
																								Cheque
																							</option>
																							<option value="Cash">Cash</option>
																							<option value="Card">Card</option>
																							<option value="DirectDebit">
																								Direct Debit
																							</option>
																						</>
																					)}
																				</select>
																				<div className="invalid-feedback">
																					{errors.receiptmethod &&
																						"Receipt Method is required"}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="form-group row">
																		<div className="col-xl-6">
																			<label className="col-lg-12 col-form-label required">
																				{t("Customer")}{" "}
																				<Tooltip content={t("Customer_Tooltip")}>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<AsyncSelect
																					{...register("selectedValue", {
																						required: true,
																					})}
																					isDisabled
																					defaultOptions
																					isClearable
																					options={options}
																					value={options.find((option) => selectedValue2 ? option.id === selectedValue2.party : selectedValue)}
																					getOptionLabel={(e) => e.customer_name}
																					getOptionValue={(e) => e.customer_name}
																					loadOptions={loadOptions}
																					onInputChange={handelInputChange}
																					onChange={handelChange}
																					name="selectedValue"
																				></AsyncSelect>
																				<div className="invalid-feedback">
																					{errors.selectedValue &&
																						"Customer is required"}
																				</div>
																			</div>
																		</div>

																		<div className="col-xl-6 ">
																			<label className="col-lg-12 col-form-label required ">
																				{t("Contract Number")}{" "}
																				<Tooltip
																					content={t("ContractNumber_Tooltip")}
																				>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<AsyncSelect
																					{...register("selectedValue2", {
																						required: true,
																					})}
																					isDisabled
																					defaultOptions
																					isClearable
																					value={selectedValue2}
																					getOptionLabel={(e) =>
																						e.contract_number
																					}
																					getOptionValue={(e) =>
																						e.contract_number
																					}
																					loadOptions={loadOptions2}
																					onInputChange={handelInputChange2}
																					onChange={handelChange2}
																					name="selectedValue2"
																				></AsyncSelect>
																				<div className="invalid-feedback">
																					{errors.selectedValue2 &&
																						"Contract Number is required"}
																				</div>
																				<input
																					type="hidden"
																					id="contract_status"
																					value="Active"
																				/>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="row">
																	<div className="form-group row">
																		<div className="col-xl-6">
																			<label className="col-lg-12 col-form-label">
																				{t("Remittance Bank")}{" "}
																				<Tooltip
																					content={t("RemittanceBank_Tooltip")}
																				>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<input
																					value={remittance_bank}
																					onChange={(e) =>
																						setRemittance_bank(e.target.value)
																					}
																					disabled={!isEditing}
																					type="text"
																					className="form-control"
																					name="remittance_bank"
																					id="remittance_bank"
																				/>
																			</div>
																		</div>
																		<div className="col-xl-6">
																			<label className="col-lg-12 col-form-label required">
																				{t("Receipt Amount")}{" "}
																				<Tooltip
																					content={t("ReceiptAmount_Tooltip")}
																				>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<CurrencyInput
																					id="input-example"
																					{...register("receiptamount", {
																						required: true,
																					})}
																					disabled
																					allowDecimals="false"
																					value={receipt_amount}
																					className="form-control"
																					onValueChange={(value) =>
																						setReceipt_amount(value)
																					}
																					name="receiptamount"
																					disableAbbreviations
																				/>
																				<div className="invalid-feedback">
																					{errors.receiptamount?.type ===
																						"required" &&
																						"Receipt Amount  is required"}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="form-group row">
																		<div className="col-xl-6">
																			<label className="col-lg-12 col-form-label">
																				{t("Receipt Reference")}{" "}
																				<Tooltip
																					content={t("ReceiptReference_Tooltip")}
																				>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<input
																					disabled={!isEditing}
																					onChange={(e) =>
																						setReceipt_reference(e.target.value)
																					}
																					value={receipt_reference}
																					type="text"
																					className="form-control input-lg"
																					name="receipt_reference"
																					id="receipt_reference"
																				/>
																			</div>
																		</div>
																		<div className="col-xl-6">
																			<label className="col-lg-12 col-form-label">
																				{t("Status")}{" "}
																				<Tooltip content={t("Status_Tooltip")}>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<input
																					value={status}
																					disabled
																					type="text"
																					id="advance_amount"
																					name="advance_amount"
																					className="form-control"
																				/>
																			</div>
																		</div>
																	</div>
																	<div className="col-xl-6">
																		<label className="col-lg-12 col-form-label">
																			{t("Comments")}{" "}
																			<Tooltip content={t("Comments_Tooltip")}>
																				<i className="fa fa-light fa-circle-info"></i>
																			</Tooltip>
																		</label>
																		<div className="col-lg-12">
																			<textarea
																				className="form-control"
																				value={comments}
																				disabled={!isEditing}
																				type="textarea"
																				name="comments"
																				onChange={(e) =>
																					setComments(e.target.value)
																				}
																			// onBlur={() => handleBlur()}
																			/>
																		</div>
																	</div>
																	<div className="col-xl-4"></div>
																</div>
																{extrafiledreceipt.length === 0 ? (
																	""
																) : (
																	<h4 className="tc mt-4">
																		{t("Additional Information")} :
																	</h4>
																)}
																<div className="form-group row">
																	{extrafiledreceipt && extrafiledreceipt.map((key, index) => (
																		<div
																			className={
																				key.enable === "True" ? "col-sm-6" : null
																			}
																		>
																			<>
																				<label
																					style={{
																						display:
																							key.enable === "True"
																								? true
																								: "none",
																					}}
																					className="col-form-label"
																				>
																					{" "}
																					{key.label}{" "}
																					<Tooltip content={key.label}>
																						<i className="fa fa-light fa-circle-info"></i>
																					</Tooltip>
																				</label>
																				<input
																					style={{
																						display:
																							key.enable === "True"
																								? true
																								: "none",
																					}}
																					id={"attribute_" + index}
																					disabled={!isEditing}
																					value={
																						attribute && attribute[index]["attribute" + index]
																							? attribute[index][
																							"attribute" + index
																							]
																							: ""
																					}
																					className="form-control mb-1"
																					name={"attribute" + index}
																					type={key.datatype}
																					placeholder={key.label}
																					onChange={(e) =>
																						onChangeextrafileds(e, index)
																					}
																				/>
																			</>
																		</div>
																	))}
																</div>
																<div className="text-left py-3">
																	<input type="hidden" id="receipt_id" />
																	<input type="hidden" id="contract_id" />
																	&nbsp;&nbsp;
																	{!isEditing && (status !== "Unidentified Amount" || status === 'Unapplied') ? (
																		<button
																			// disabled={successful ? true : false}
																			disabled={applyloading ? true : false}
																			type="button"
																			onClick={handleApplyGlobally}
																			className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-sm"
																		>
																			{applyloading === false ? (
																				// t("Apply")
																				t("Apply Receipt")
																			) : (
																				<ButtonLoading />
																			)}
																		</button>
																	) : (
																		""
																	)}
																	&nbsp;&nbsp;
																	{/* {!isEditing && (status !== "Cancelled" && applied_amount === 0) ? ( */}
																	{/* <button
																			disabled={canceldisable ? true : false}
																			type="button"
																			onClick={updatereceipt}
																			className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-md"
																		>
																			{cancelbtnloading === false ? (
																				t("CANCEL")
																			) : (
																				<ButtonLoading />
																			)}
																		</button> */}
																	{/* // ) : (
																	// 	""
																	// )} */}
																	&nbsp;&nbsp;
																	{status === "Unapplied" || status === 'Partially Applied' ? (
																		<button
																			type="button"
																			onClick={handleEdit}
																			disabled={isEditing}
																			className={`${isEditing ? 'btn-apply-custom border-0 btn btn-primary btn-gradient-primary btn-sm' : 'btn-apply border-0 btn btn-primary btn-gradient-primary btn-sm'}`}
																			style={{ marginRight: '10px' }}
																		>
																			{t("Edit")}
																		</button>
																	) : (
																		""
																	)}
																	{isEditing && (
																		<>
																			<button
																				type="button"
																				onClick={handleSave}
																				className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-sm"
																			>
																				{t("Update")}
																			</button>
																			&nbsp;&nbsp;
																			<button
																				type="button"
																				onClick={handleCancelEdit}
																				className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-sm"
																			>
																				{t("Reset")}
																			</button>
																		</>
																	)}
																	{
																		status === "Fully Applied" || status === "Partially Applied" ?

																			<button
																				type="button"
																				onClick={handlesmoothInvoice}
																				className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-sm"
																				style={{ marginLeft: '10px' }}
																			>
																				{t("Application Reversal")}

																			</button>

																			:
																			""
																	}
																	{
																		// status !==  "Unapplied" & status !=="Reversed"?
																		status !== "Reversed" ?

																			<button
																				disabled={cashLoading ? true : false}
																				type="button"
																				onClick={handleCashReceiptReversalconfirmAlert}
																				className="btn-apply border-0 btn btn-primary btn-gradient-primary btn-sm"
																				style={{ marginLeft: '10px' }}
																			>
																				{cashLoading === false ? (
																					// status === 'Unapplied'?
																					// t("Cancel"):
																					// t("Application Reversal")
																					// :
																					// t("Receipt Reversal")
																					t("Reverse Receipt")
																				) : (
																					<ButtonLoading />
																				)}
																			</button>

																			:
																			""
																	}

																</div>
															</>
														}
														<CheckButton
															style={{ display: "none" }}
															ref={checkBtn}
														/>
													</Form> :
													<ContentLoader
														viewBox="0 0 1000 550"
														backgroundColor="rgba(0,0,0,0.06)"
														foregroundColor="rgba(0,0,0,0.12)"
													>
														<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
														<circle cx="879" cy="123" r="11" />
														<circle cx="914" cy="123" r="11" />
														<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
														<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
														<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
														<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
														<circle cx="880" cy="184" r="11" />
														<circle cx="915" cy="184" r="11" />
														<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
														<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
														<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
														<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
														<circle cx="881" cy="242" r="11" />
														<circle cx="916" cy="242" r="11" />
														<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
														<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
														<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
														<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
														<circle cx="882" cy="303" r="11" />
														<circle cx="917" cy="303" r="11" />
														<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
														<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
														<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
														<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
														<circle cx="881" cy="363" r="11" />
														<circle cx="916" cy="363" r="11" />
														<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
														<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
														<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
														<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
														<circle cx="882" cy="424" r="11" />
														<circle cx="917" cy="424" r="11" />
														<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
														<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
														<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
														<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
														<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
														<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
														<circle cx="882" cy="484" r="11" />
														<circle cx="917" cy="484" r="11" />
														<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
														<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
														<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
														<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
														<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
														<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
														<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
														<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
														<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
														<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
													</ContentLoader>
												}
											</div>
										</div>
									</div>
									<div className="col-md-4">
										<div className="card">
											<div className="card-body">
												{isLoading !== true ?
													<div className="col-xl-12">
														<div className="form-group row">
															<label className="col-lg-12 col-form-label required">
																{t("Receipt Number")}{" "}
																<Tooltip content={t("ReceiptNumber_Tooltip")}>
																	<i className="fa fa-light fa-circle-info"></i>
																</Tooltip>
															</label>
															<div className="col-lg-12">
																<input
																	value={receipt_number}
																	disabled
																	type="text"
																	className="form-control"
																	name="receipt_number"
																	id="receipt_number"
																	{...register("receipt_number", {
																		onChange: (e) => {
																			setReceipt_number(e.target.value);
																		},
																		required: false,
																	})}
																/>
																<div className="invalid-feedback">
																	{errors.receipt_number?.type === "required" &&
																		"Receipt Number  is required"}
																</div>
															</div>
														</div>
														<div className="col-xl-12">
															<Form
																role="form text-left"
																onSubmit={handleSubmit(handleRegister)}
																ref={form}
																action="."
																method="POST"
																id="addReceiptForm"
															>
																{
																	<>
																		<div className="form-group row">
																			<label className="col-lg-12 col-form-label required">
																				{t("Receipt Date")}{" "}
																				<Tooltip
																					content={t("ReceiptDate_Tooltip")}
																				>
																					<i className="fa fa-light fa-circle-info"></i>
																				</Tooltip>
																			</label>
																			<div className="col-lg-12">
																				<DatePicker
																					className="form-control datepick"
																					{...register("receiptdate", {
																						required: true,
																					})}
																					selected={
																						receipt_date
																							? new Date(receipt_date)
																							: new Date()
																					}
																					onChange={(e) => handelReceipt_Date(e)}
																					name="receiptdate"
																					// value={Helper.DateNormal(receipt_date)}
																					disabled
																					placeholderText={"mm/dd/yyyy"}
																					showYearDropdown // year show and scrolldown alos
																					scrollableYearDropdown
																					showMonthDropdown
																					dropdownMode="select"
																				/>
																				<div className="invalid-feedback">
																					{errors.receiptdate &&
																						"Receipt Date  is required"}
																				</div>
																			</div>
																		</div>

																		<div className="col-xl-12">
																			<div className="form-group row">
																				<label className="col-lg-12 col-form-label">
																					{t("Applied Amount")}{" "}
																					<Tooltip
																						content={t("AppliedAmount_Tooltip")}
																					>
																						<i className="fa fa-light fa-circle-info"></i>
																					</Tooltip>
																				</label>
																				<div className="col-lg-12">
																					<input
																						disabled
																						value={Helper.Amount(Math.abs(applied_amount))}
																						type="text"
																						id="applied_amount"
																						name="applied_amount"
																						className="form-control"
																					/>
																				</div>
																			</div>
																		</div>
																		<div className="col-xl-12">
																			<div className="form-group row">
																				<label className="col-lg-12 col-form-label">
																					{t("Unapplied Amount")}{" "}
																					<Tooltip
																						content={t("UnAppliedAmount_Tooltip")}
																					>
																						<i className="fa fa-light fa-circle-info"></i>
																					</Tooltip>
																				</label>
																				<div className="col-lg-12">
																					<input
																						disabled
																						value={Helper.Amount(receipt_amount - applied_amount)}
																						type="text"
																						id="unapplied_amount"
																						name="unapplied_amount"
																						className="form-control"
																					/>
																				</div>
																			</div>
																		</div>
																	</>
																}
																<CheckButton
																	style={{ display: "none" }}
																	ref={checkBtn}
																/>
															</Form>
														</div>
													</div> :
													<ContentLoader
														viewBox="0 0 1000 550"
														backgroundColor="rgba(0,0,0,0.06)"
														foregroundColor="rgba(0,0,0,0.12)"
													>
														<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
														<circle cx="879" cy="123" r="11" />
														<circle cx="914" cy="123" r="11" />
														<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
														<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
														<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
														<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
														<circle cx="880" cy="184" r="11" />
														<circle cx="915" cy="184" r="11" />
														<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
														<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
														<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
														<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
														<circle cx="881" cy="242" r="11" />
														<circle cx="916" cy="242" r="11" />
														<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
														<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
														<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
														<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
														<circle cx="882" cy="303" r="11" />
														<circle cx="917" cy="303" r="11" />
														<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
														<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
														<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
														<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
														<circle cx="881" cy="363" r="11" />
														<circle cx="916" cy="363" r="11" />
														<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
														<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
														<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
														<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
														<circle cx="882" cy="424" r="11" />
														<circle cx="917" cy="424" r="11" />
														<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
														<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
														<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
														<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
														<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
														<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
														<circle cx="882" cy="484" r="11" />
														<circle cx="917" cy="484" r="11" />
														<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
														<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
														<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
														<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
														<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
														<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
														<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
														<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
														<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
														<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
													</ContentLoader>
												}
											</div>
										</div>
										<div className="card">
											<div className="card-body">
												{/* <button className="btn btn-primary" type="button" onClick={handleInvoice}>Invoice Generate</button> */}
												{/* <table>
																			  <thead>
																			  <tr>
																				  <th>{t("Documents")}</th>
																				</tr>
																			  </thead>
																			  <tbody>
																				{getInvoiceDetails.map((val, index) => (
																				  <tr key={index}>
																					<td
																					  className='hyperlink' 
																					  // onClick={(e) => downloadFile(e, PDF + `${val.invoicepdf_path}`)}
																					  // onClick={(e) => downloadFile(PDF + `${val.invoicepdf_path}`)}
																					  onClick={() => downloadFile(PDF + val.invoicepdf_path, val.invoicepdf_name)}
																					>
																					  {val.invoicepdf_name}
																					</td>
																				  </tr>
																				))}
																			  </tbody>
																			</table> */}
												<h6 className="mb-3">Documents ({documents.length})</h6>
												<div className="documents-list">
													{currentDocuments && currentDocuments.map(doc => (
														<div className="document-item" key={doc.id}>
															<div className="document-icon">
																{doc.type === 'pdf' ? '📄' :
																	doc.type === 'doc' || doc.type === 'docx' ? '📝' :
																		doc.type === 'jpg' || doc.type === 'jpeg' || doc.type === 'png' ? '🖼️' :
																			'📁'}
															</div>
															<div className="document-info">
																<div className="document-name">{doc.title}</div>
																<div className="document-metadata">
																	{Helper.DateNormal(doc.uploaded_at)}
																</div>
																<div className="document-tags">
																	{doc.tags.split(',').map((tag, index, arr) => (
																		<span key={index} className="tag-pill"
																			onClick={() => handleTages()}>{tag.trim()}{index < arr.length - 1 ? ', ' : ''}</span>
																	))}
																</div>
															</div>
															<div className="document-actions">
																<button className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
																	onClick={() => handleDownload(doc.file)}
																>
																	Download
																</button>
															</div>
														</div>
													))}
													<div className="pagination-controls d-flex justify-content-between mt-3">
														<button
															className="pag-btn"
															onClick={handlePrevious}
															disabled={currentPage === 1}
														>
															Previous
														</button>

														<span>Page {currentPage} of {totalPages}</span>

														<button
															className="pag-btn"
															onClick={handleNext}
															disabled={currentPage === totalPages}
														>
															Next
														</button>
													</div>

												</div>

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{isLoading !== true ?
						<><div className="pt-3 mt-2 ">
							<h5 className="mb-3">{t("Open Invoices")}</h5>
							<MaterialTable
								style={{
									backgroundColor: "var(--bs-table-bg)",
									borderBottomWidth: "1px",
									boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
								}}
								columns={[
									{
										title: `${t("Invoice Number")}`,
										field: "invoice_number",
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "left",
										},
										cellStyle: {
											textAlign: "left",
											fontSize: 12,
										},
										render: (rowData) => (
											<>
												<div className="d-xl-none tc d-md-none d-lg-none">
													{t("Invoice Number")}{" "}
												</div>
												<div
													className="hyperlink"
													onClick={() => handleView(rowData.id, rowData.invoice_status)}
												>
													{rowData.invoice_number}
												</div>
											</>
										),
									},
									{
										title: `${t("Transaction Date")}`,
										field: "creation_date",
										render: (rowData) => <>
											<div className="d-xl-none tc d-md-none d-lg-none">
												{t("Transaction Date")}{" "}
											</div><div>{Helper.DateNormal(rowData.creation_date)}</div></>,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "left",
										},
										cellStyle: {
											textAlign: "left",
											fontSize: 12,
										},
									},
									{
										title: `${t("Due Date")}`,
										field: "due_date",
										render: (rowData) => <>
											<div className="d-xl-none tc d-md-none d-lg-none">
												{t("Due Date")}{" "}
											</div><div>{Helper.DateNormal(rowData.due_date)}</div></>,
										// export: false,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "left",
										},
										cellStyle: {
											textAlign: "left",
											fontSize: 12,
										},
									},
									{
										title: `${t("Invoice Amount")}`,
										field: "total_amount",
										render: (rowData) => <>
											<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
											>
												{t("Invoice Amount")}{" "}
											</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }} >{Helper.Amount(rowData.total_amount)}</div></>,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "right",
										},
										// cellStyle: {
										// 	textAlign: "right",
										// 	fontSize: 12,
										// },
									},
									{
										title: `${t("Remaining Amount")}`,
										field: "balance_amount",
										render: (rowData) => <>
											<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
											>
												{t("Remaining Amount")}
											</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.balance_amount)}</div></>,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "right",
										},
										// cellStyle: {
										// 	textAlign: "right",
										// 	fontSize: 12,
										// },
									},
									{
										title: `${t("Day Past Due")}`,
										field: "",
										render: (rowData) => <>
											<div className="d-xl-none tc d-md-none d-lg-none">
												{t("Day Past Due")}{" "}
											</div><div>{Helper.DueDays(rowData.due_date)}</div></>,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "left",
										},
										cellStyle: {
											textAlign: "left",
											fontSize: 12,
										},
									},
									{
										title: `${t("Contract No")}`,
										field: "contract_id",
										render: (rowData) => <>
											<div className="d-xl-none tc d-md-none d-lg-none">
												{t("Contract No")}{" "}
											</div>
											<div>{(rowData.contract_id.contract_number ? rowData.contract_id.contract_number : "")}</div></>,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "left",
										},
										cellStyle: {
											textAlign: "left",
											fontSize: 12,
										},
									},
									{
										title: `${t("Customer Name")}`,
										field: "customer_name",
										render: (rowData) => <>
											<div className="d-xl-none tc d-md-none d-lg-none">
												{t("Customer Name")}{" "}
											</div><div>{(rowData.customer_name ? rowData.customer_name : "")}</div></>,
										headerStyle: {
											verticalAlign: "inherit",
											fontWeight: "bold",
											textAlign: "left",
										},
										cellStyle: {
											textAlign: "left",
											fontSize: 12,
										},
									},
									{
										title: "Actions",
										editable: false,
										render: (rowData) => <>
											<div className="d-xl-none tc d-md-none d-lg-none">
												{t("Actions")}{" "}
											</div><div>
												{rowData.balance_amount !== 0 ? (
													<button
														// className="btn bg-gradient-secondary btn-sm ms-auto mb-0"
														className="btn btn-primary btn-gradient-primary btn-sm ms-auto mb-0"
														onClick={() => handleApplyManually(rowData.id)}
														disabled={isEditing === true}
													>
														Apply
													</button>
												) : (
													<button
														disabled
														className="btn bg-gradient-secondary ms-auto mb-0"
													>
														Applied
													</button>
												)}
											</div></>
									},
								]}
								data={items}
								options={{
									headerStyle: {
										backgroundColor: "",
										color: "#245C7F",
										fontSize: 9,
									},
									rowStyle: (rowData, index) => {
										if (index % 2) {
											return { backgroundColor: "#fff" };
										}
									},
									sorting: true,
									search: false,
									toolbar: false,
									paging: true,
									pageSize: 10, // make initial page size
									emptyRowsWhenPaging: false, // To avoid of having empty rows
									pageSizeOptions: [10, 20, 25, 50],
									paginationType: "stepped",
									showFirstLastPageButtons: false,
									actionsColumnIndex: -1,
								}} />
						</div><div className="pt-4 mt-2" ref={invoicePaidRef}>
								<h5 className="mb-3">{t("Invoices Paid")}</h5>
								<MaterialTable
									style={{
										backgroundColor: "var(--bs-table-bg)",
										borderBottomWidth: "1px",
										boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
									}}
									columns={[
										{
											title: `${t("Invoice Number")}`,
											field: "invoice_id.invoice_number",
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "left",
											},
											cellStyle: {
												textAlign: "left",
												fontSize: 12,
											},
											render: (rowData) => (
												<>
													<div className="d-xl-none tc d-md-none d-lg-none">
														{t("Invoice Number")}{" "}
													</div>
													<div
														className="hyperlink"
														onClick={() => handleView(rowData.invoice_id.id, rowData.invoice_id.invoice_status)}
													>
														{rowData.invoice_id.invoice_number}
													</div>
												</>
											),
										},
										{
											title: `${t("Transaction Date")}`,
											field: "invoice_id.creation_date",
											render: (rowData) => <>
												<div className="d-xl-none tc d-md-none d-lg-none">
													{t("Transaction Date")}{" "}
												</div><div>{Helper.DateNormal(rowData.invoice_id.creation_date)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "left",
											},
											cellStyle: {
												textAlign: "left",
												fontSize: 12,
											},
										},
										{
											title: `${t("Due Date")}`,
											field: "invoice_id.due_date",
											render: (rowData) => <>
												<div className="d-xl-none tc d-md-none d-lg-none">
													{t("Due Date")}{" "}
												</div><div>{Helper.DateNormal(rowData.invoice_id.due_date)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "left",
											},
											cellStyle: {
												textAlign: "left",
												fontSize: 12,
											},
										},
										{
											title: `${t("Invoice Amount")}`,
											field: "invoice_id.total_amount",
											render: (rowData) => <>
												<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
												>
													{t("Invoice Amount")}{" "}
												</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.invoice_id.total_amount)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "right",
											},
											// cellStyle: {
											// 	textAlign: "right",
											// 	fontSize: 12,
											// },
										},
										{
											title: `${t("Applied Amount")}`,
											field: "",
											render: (rowData) => <>
												<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
												>
													{t("Applied Amount")}{" "}
												</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.invoice_id.total_amount - rowData.invoice_id.balance_amount)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "right",
											},
											// cellStyle: {
											// 	textAlign: "right",
											// 	fontSize: 12,
											// },
										},
										{
											title: `${t("Remaining Amount")}`,
											field: "invoice_id.balance_amount",
											render: (rowData) => <>
												<div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
												>
													{t("Remaining Amount")}
												</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.invoice_id.balance_amount)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "right",
											},
											// cellStyle: {
											// 	textAlign: "right",
											// 	fontSize: 12,
											// },
										},
										{
											title: `${t("Day Past Due")}`,
											field: "invoice_id.due_date",
											render: (rowData) => <>
												<div className="d-xl-none tc d-md-none d-lg-none">
													{t("Day Past Due")}{" "}
												</div><div>{Helper.DueDays(rowData.invoice_id.due_date)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "left",
											},
											cellStyle: {
												textAlign: "left",
												fontSize: 12,
											},
										},
										{
											title: `${t("Contract No")}`,
											field: "contract_number",
											render: (rowData) => <>
												<div className="d-xl-none tc d-md-none d-lg-none">
													{t("Contract No")}{" "}
												</div><div>{(rowData.contract_id)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "left",
											},
											cellStyle: {
												textAlign: "left",
												fontSize: 12,
											},
										},
										{
											title: `${t("Customer Name")}`,
											field: "customer_name",
											render: (rowData) => <>
												<div className="d-xl-none tc d-md-none d-lg-none">
													{t("Customer Name")}{" "}
												</div><div>{(rowData.customer_id)}</div></>,
											headerStyle: {
												verticalAlign: "inherit",
												fontWeight: "bold",
												textAlign: "left",
											},
											cellStyle: {
												textAlign: "left",
												fontSize: 12,
											},
										},
									]}
									data={invoicepaid}
									onSelectionChange={handleRowSelectionChange}

									options={{
										headerStyle: {
											backgroundColor: "",
											color: "#245C7F",
											fontSize: 9,
										},
										rowStyle: (rowData, index) => {
											if (index % 2) {
												return { backgroundColor: "#fff" };
											}
										},
										sorting: true,
										search: false,
										toolbar: false,
										paging: true,
										pageSize: 10, // make initial page size
										emptyRowsWhenPaging: false, // To avoid of having empty rows
										pageSizeOptions: [10, 20, 25, 50],
										paginationType: "stepped",
										showFirstLastPageButtons: false,
										actionsColumnIndex: -1,
										selection: true,
										showTextRowsSelected: false,
									}} />
							</div>
							{
								selectedRows.length > 0 ?
									<div className="">
										<button disabled={receiptapplicationbutton ? true : false} className="btn btn-primary btn-sm"
											onClick={(e) => handleReceiptReverse(e)}
										>
											{receiptapplicationbutton === false ?
												(t("Reverse Application ")) :
												(
													<ButtonLoading />
												)}
										</button>
									</div>
									: ""

							}
						</>
						:
						<ContentLoader
							viewBox="0 0 1000 550"
							backgroundColor="rgba(0,0,0,0.06)"
							foregroundColor="rgba(0,0,0,0.12)"
						>
							<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
							<circle cx="879" cy="123" r="11" />
							<circle cx="914" cy="123" r="11" />
							<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
							<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
							<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
							<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
							<circle cx="880" cy="184" r="11" />
							<circle cx="915" cy="184" r="11" />
							<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
							<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
							<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
							<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
							<circle cx="881" cy="242" r="11" />
							<circle cx="916" cy="242" r="11" />
							<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
							<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
							<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
							<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
							<circle cx="882" cy="303" r="11" />
							<circle cx="917" cy="303" r="11" />
							<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
							<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
							<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
							<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
							<circle cx="881" cy="363" r="11" />
							<circle cx="916" cy="363" r="11" />
							<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
							<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
							<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
							<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
							<circle cx="882" cy="424" r="11" />
							<circle cx="917" cy="424" r="11" />
							<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
							<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
							<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
							<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
							<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
							<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
							<circle cx="882" cy="484" r="11" />
							<circle cx="917" cy="484" r="11" />
							<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
							<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
							<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
							<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
							<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
							<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
							<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
							<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
							<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
							<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
						</ContentLoader>
					}
				</div>
			</div>
		</>
	);
}

export default EditRecipts;
